import updateSelectedLogIndex from '../mutators/updateSelectedLogIndex';
import { CalendarCacheUpdateLog } from '../store/schema/CalendarCacheDiagnosticsStore';
import getStore from '../store/store';
import { observer } from 'mobx-react';
import { Button } from 'office-ui-fabric-react/lib/Button';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { formatUserDateTime } from 'owa-datetime';
import * as React from 'react';
import { Inspector } from 'react-inspector';
import {
    copyToClipboard,
    createCopyEventListener,
} from 'owa-diagnostics/lib/utils/copyToClipboardUtils';
import {
    DetailsList,
    Selection,
    SelectionMode,
} from 'office-ui-fabric-react/lib/components/DetailsList';

let styles = require('./CalendarCacheDiagnosticsPanel.scss');

@observer
export default class CalendarCacheDiagnosticsPanel extends React.Component<{}> {
    private selection: Selection;
    private copyEventListener: (e: ClipboardEvent) => void;

    constructor(props: any) {
        super(props);
        this.selection = new Selection({
            selectionMode: SelectionMode.multiple,
            onSelectionChanged: () => {
                if (this.selection.getSelectedCount() == 1) {
                    updateSelectedLogIndex(Number(this.selection.getSelection()[0].key));
                }
            },
            canSelectItem: () => true,
            getKey: this.getKey,
        });
        this.copyEventListener = createCopyEventListener<CalendarCacheUpdateLog>(
            () => getStore().cacheUpdateLogs.reverse(), // we reverse the list in the view, so we should reverse it here too
            ['timestamp', 'lockId', 'updateMessage']
        );
    }

    private getKey(item) {
        return item.key;
    }

    componentDidMount() {
        document.addEventListener('copy', this.copyEventListener);
    }

    componentWillUnmount() {
        document.removeEventListener('copy', this.copyEventListener);
    }

    render() {
        const { cacheUpdateLogs, selectedLogIndex } = getStore();
        const logs = cacheUpdateLogs
            .map((log, index) => ({
                UpdateMessage: log.updateMessage,
                LockId: log.lockId,
                TimeStamp: formatUserDateTime(log.timestamp),
                key: index,
            }))
            .reverse();

        return (
            <div>
                <Button onClick={copyToClipboard} className={styles.button}>
                    {'Copy all rows to clipboard'}
                </Button>
                <div className={styles.container}>
                    <div className={styles.table}>
                        <DetailsList
                            items={logs}
                            selection={this.selection}
                            selectionMode={SelectionMode.single}
                            setKey="calendarCache"
                        />
                    </div>
                    {selectedLogIndex != -1 && (
                        <div className={styles.rightPanel}>
                            {this.renderObject(
                                cacheUpdateLogs[selectedLogIndex].timestamp,
                                'TimeStamp'
                            )}
                            {this.renderObject(cacheUpdateLogs[selectedLogIndex].lockId, 'LockId')}
                            {this.renderObject(
                                cacheUpdateLogs[selectedLogIndex].updateMessage,
                                'UpdateMessage'
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    private renderObject(object: Object, title: string) {
        return (
            <>
                <Label>{title}</Label>
                <Inspector data={object} />
            </>
        );
    }
}

export const renderPanel = () => <CalendarCacheDiagnosticsPanel />;
